import ComplexPolymerRegTableColumnTransformerBase from '../ComplexPolymerRegTableColumnTransformerBase';

export default class OligoConjugateRegTableColumnTransformer extends ComplexPolymerRegTableColumnTransformerBase {}
